import { render, staticRenderFns } from "./USPs.vue?vue&type=template&id=bf386b60&"
import script from "./USPs.vue?vue&type=script&lang=js&"
export * from "./USPs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports